import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { t } from 'translation'
import { connect } from 'react-redux'
import history from 'utils/appHistory'

import BgLoginImg from 'assets/woman.jpg'
import LogoLoginImg from 'assets/logo_tr.png'

const MainPage = (props) => {
  const [scaleClassIsSet, setScaleClassIsSet] = useState(false)

  useEffect(() => {
    document.documentElement.classList.add('no_scale_mod')
    setScaleClassIsSet(true)
    return
  }, [])

  const showWelcomeVideo = props.attributes?.permissions?.features?.alwaysOnWelcomeVideo

  const redirectPath =
    showWelcomeVideo && !props.isDoctor
      ? `/welcome`
      : props.isDoctor
      ? `/welcome-doctor`
      : '/indication-select'

  return (
    <section className="section login_mod">
      {props.isAuthenticated && history.location.path !== redirectPath ? (
        <Redirect to={redirectPath} />
      ) : null}
      {scaleClassIsSet && (
        <>
          <div className="section_bg login_mod">
            <img className="section_bg_img" src={BgLoginImg} alt="section background" />
          </div>
          <div className="section_in login_mod">
            <div className="logo login_mod">
              <img className="logo_img" src={LogoLoginImg} alt="logo" />
            </div>
            <div className="tab_content_wrap auth_block">
              <h1 className="section_title v4_mod color_mod offset_v4_mod decor_mod center_mod">
                {t('requestAccess.MAIN_INSCRIPTION')}
              </h1>
              <div className="auth_block_descr decor_mod offset_mod center_lvl_mod">
                <p>{t('requestAccess.MAIN_DESCRIPTION')}</p>
              </div>
              <div className="phone_system_buttons offset_mod">
                <button
                  className="phone_system_buttons_item btn_download"
                  onClick={() => history.push('/login')}
                >
                  {t('requestAccess.MEMBER')}
                </button>
                <button
                  className="phone_system_buttons_item btn_download"
                  onClick={() => history.push('/signup')}
                >
                  {t('requestAccess.SIGNUP')}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  )
}

const mapStateToProps = ({
  auth: { attributes, error, loading, isAuthenticated, isDoctor },
}) => {
  return {
    attributes,
    loading,
    isAuthenticated,
    isDoctor,
    authError: error,
  }
}

export default connect(mapStateToProps)(MainPage)
